<template>
  <div>
    <v-navigation-drawer v-model="drawer" bottom fixed app>
      <v-list>
        <v-list-item>
          <v-col>
        <v-img :src="require('@/assets/LogoBetask.svg')" max-width="70px"></v-img>
          </v-col>
          <v-col>
        <v-img class="ml-1 mr-9" :src="require('@/assets/GroupBetask.svg')" max-width="80px"></v-img>
          </v-col>
          <!-- <v-list-item-avatar>-->
            <!-- <v-img src='./assets/logo_vgroup.png' /> -->
            <!-- <v-img :src="session.data.logo"></v-img> -->
            <!-- <v-img :src="require('@/assets/logo.png')"></v-img> -->
          <!-- </v-list-item-avatar> -->
            <!-- <v-col cols="8">
            <v-list-item-title class="menu-head"> BeTask </v-list-item-title>
            </v-col> -->
        </v-list-item>
      </v-list>
      <v-list-group
      dense
        :value="true"
        prepend-icon="mdi-shopping"
        color="white"
        no-action
        v-if="manage.length > 0"
      >
      <template v-slot:activator>
          <v-list-item-title class="menu-head">จัดการข้อมูลร้าน</v-list-item-title>
        </template>

        <v-list-item
        dense
          v-for="(item, i) in manage"
          :key="i"
          :to="item.to"
          router
          exact
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon" dense  color="white"></v-icon>
          </v-list-item-icon>
          <v-list-item-title dense v-text="item.title"></v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'Loyalty',
      drawer: true,
      mini: false,
      session: this.$session.getAll(),
      manage: [],
      items: []
    }
  },
  computed: {},
  mounted () {
    this.items = []
    this.manageChk()
  },
  methods: {
    manageChk () {
      this.manage = [
        { title: 'สร้างร้านค้า', icon: 'mdi-account-edit', to: '/System/ManageShop' }
      ]
    }
  }
}
</script>

<style lang="css" scoped>

#img_bt {
  width: 50px;
  height: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/SidebarManageShop.vue